<form class="form-popup" [formGroup]="formGroup">
  <div class="modal-body">
          <div class="row top10 vcenter">
            <div class="col-xs-4 text-right">
              <b>Select Qual Task (if exists):</b>
            </div>
            <div class="col-xs-8">
              <aims-lookup style="width:100%"
                           name="SelectQualTask"
                           id="selectQualTask"
                           [gridText]="'Select a Qualification Task to link to: ' + qualDesc"
                           [values]="qualTaskPuValues | async"
                           [idPropertyName]="'qualTaskId'"
                           [displayPropertyName]="'qtDesc'"
                           formControlName="qualTaskId"
                           [columnsInGrid]="qualificationTaskLookupColumns"
                           (valueChangeObj)="handleQualTaskChange($event)">
              </aims-lookup>
            </div>
          </div>

          <hr style="margin-top:2px;margin-bottom:2px" />

          <ngContainer *ngIf="qualTaskId == null || qualTaskId == 0">
          <div class="row top10 vcenter">
            <div class="col-xs-4 text-right">
              <b>Description:</b>
            </div>
            <div class="col-xs-8">
              <input class="k-textbox" type="text" style="width:100%" formControlName="qtDesc"
                          [required]="qualTaskId == null || qualTaskId == 0" />
            </div>
          </div>

          <div class="row top10 vcenter">
            <div class="col-xs-4 text-right">
              <b>Interval In Months:</b>
            </div>
            <div class="col-xs-8">
              <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.NUMBER"
                      name="IntervalInMonths"
                      formControlName="intervalInMonths"
                      [required]="qtDesc != null"
                      [min]="0" [maxDecimals]="0">
              </aims-numeric>
            </div>
          </div>

          <div class="row top10 vcenter">
            <div class="col-xs-4 text-right">
              <b>Work Section Owner:</b>
            </div>
            <div class="col-xs-8">
              <mat-form-field appearance="fill" >
                <mat-select name="qualOwnerId" formControlName="qualTaskWsOwnerId">
                  <mat-option *ngFor="let w of workSectionValues | async" [value]="w.workSectionId"> {{ w.workSection }} </mat-option>
                </mat-select>
              </mat-form-field>
                <!-- (selectionChange)="getSelectedTable($event)" -->
            </div>
          </div>

          <div class="row top10 vcenter">
            <div class="col-xs-4 text-right">
              <b>HAZWOPER ?:</b>
            </div>
            <div class="col-xs-8">
              <input type="checkbox"
                     name="Hazwoper"
                     formControlName="hazwoper" />
            </div>
          </div>
          </ngContainer>

          </div>

</form>
